import { isEqual } from 'lodash';
import { SERVER, ACCIONES_ROW } from 'skrit-web-framework/constantes';
import { downloadBlob } from 'skrit-web-framework/utils';
import translate from 'skrit-web-framework/translator';
import Swal from 'sweetalert2';

import store from '../store/index.js';

export function getEjercicios() {
    let state = store.getState();
    let config = state.config || {};
    let ejercicios = config.ejerciciosFiscales || [];
    return ejercicios.map((ejercicio, i) => ({
        id: ejercicio,
        text: ejercicio,
        default: i === 0,
    }));
}

export function getSeries() {
    let state = store.getState();
    let config = state.config || {};
    let series = config.seriesPermitidas || [];
    return series.map((e) => ({
        id: e.SER_ID,
        text: e.SER_DESCRIPCION,
        default: e.SER_DEFECTO,
    }));
}

export function getSeriesFull() {
    let state = store.getState();
    let config = state.config || {};
    let series = config.seriesPermitidas || [];
    return series.map((e) => ({
        ...e,
        id: e.SER_ID,
        text: e.SER_DESCRIPCION,
        default: e.SER_DEFECTO,
    }));
}

export function getEmpresa() {
    const state = store.getState();
    const config = state.config || {};
    let activeCompany = config.activeCompany;
    const configEmpresa = config.configEmpresas.find(
        (e) => e.EMP_ID === activeCompany
    );
    if (configEmpresa != null) {
        return configEmpresa;
    }
    return null;
}

export function doAPICall(url, params, type = 'json') {
    const def = {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(SERVER + url, { ...def, ...params })
        .then((res) => {
            if (!res.ok) throw Error(res.status);
            if (type === 'blob') return res.blob();
            if (type === 'text') return res.text();
            return res.json();
        })
        .catch((e) => e);
}

export function cleanForURI(value) {
    return encodeURIComponent(
        value
            .replace(/\s/gi, '')
            .replace(/\//gi, '%2F')
            .replace(/\\/gi, '%5C')
            .toUpperCase()
    );
}

export function parseByteArrayToString(byteArray) {
    return new TextDecoder('utf-8')
        .decode(new Uint8Array(byteArray))
        .match(/[^\r\n]+/g)
        .filter((e) => e);
}

export function enviarEmailPDF(row) {
    doAPICall('/Correo/EnvioPDF', {
        method: 'POST',
        body: JSON.stringify({
            CorreosDestinatarios: row.CorreosDestinatarios,
            Asunto: row.Asunto,
            CC: row.CC,
            Cuerpo: row.Cuerpo,
            DocumentosAdjuntos: row.DocumentosAdjuntos,
            tipo: row.tipo,
        }),
    }).then((resp) => {
        if (resp.Ok) {
            Swal.fire({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                text: translate('correo_enviado'),
                type: 'success',
                customClass: {
                    container: 'windows-alert ',
                },
                timer: 8000,
            });
        } else {
            Swal.fire({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                text: 'Error: ' + resp.MensajeError,
                type: 'error',
                customClass: {
                    container: 'windows-alert',
                },
                timer: 8000,
            });
        }
    });
}

/**
 * Apply a validation to confirm if the sended email it's correct
 * @param {String} email  email to verify
 * @returns {Boolean} Returns the boolean value if the email it's valid
 */
export function validateEmail(email) {
    let validEmail =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (validEmail.test(email)) return true;
    return false;
}

export function addLineasUpdateFecha(before = [], after = []) {
    return after
        .filter((e) =>
            before.some((elem) => elem.pk === e.pk && isEqual(elem, e))
        )
        .map((e) => ({
            ...e,
            Accion: ACCIONES_ROW.UPDATE,
        }));
}

export function addAllEjercicios(ejercicios) {
    let allYears = [];
    ejercicios.map((e, i) => {
        if (i === 0) {
            allYears.push({
                id: null,
                text: translate('todos_los_anyos'),
                default: true,
            });
        }
        allYears.push({
            ...e,
            default: false,
        });
    });
    return allYears;
}

export function addAllSeries(series) {
    let allSeries = [];
    series.map((e, i) => {
        if (i === 0) {
            allSeries.push({
                id: null,
                text: translate('todas_las_series'),
                default: true,
            });
        }
        allSeries.push({
            ...e,
            default: false,
        });
    });
    return allSeries;
}

export function exportarXML(xml, fileName) {
    var blob = new Blob([xml], { type: 'application/xml' });
    downloadBlob(blob, fileName + '.xml');
}

export function windowsAlert(message) {
    Swal.fire({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        text: message,
        type: 'success',
        customClass: {
            container: 'windows-alert ',
        },
        timer: 8000,
    });
}

export function getClientes() {
    let state = store.getState();
    let config = state.config || {};
    return {
        codigo: config.cliente,
        almacen: config.almacen,
        centro: config.centro,
    };
}
